module.exports = __webpack_public_path__ + "static/media/Hatt-min.7d1fb1b5.PNG";